export const knowsAboutDict = {
  en: [
    {
      '@type': 'Thing',
      name: 'Permanent Residency',
      sameAs: [
        'https://en.wikipedia.org/wiki/Permanent_residency',
        'https://www.wikidata.org/wiki/Q689095',
      ],
    },
    {
      '@type': 'Thing',
      name: 'Residence Permit',
      sameAs: [
        'https://en.wikipedia.org/wiki/Residence_permit',
        'https://www.wikidata.org/wiki/Q3529607',
      ],
    },
    {
      '@type': 'Thing',
      name: 'Citizenship',
      sameAs: [
        'https://en.wikipedia.org/wiki/Citizenship',
        'https://www.wikidata.org/wiki/Q42138',
      ],
    },
    {
      '@type': 'Thing',
      name: 'Economic citizenship',
      sameAs: [
        'https://en.wikipedia.org/wiki/Economic_citizenship',
        'https://www.wikidata.org/wiki/Q5333443',
      ],
    },
    {
      '@type': 'Thing',
      name: 'Naturalization',
      sameAs: [
        'https://en.wikipedia.org/wiki/Naturalization',
        'https://www.wikidata.org/wiki/Q841440',
      ],
    },
  ],
  de: [
    {
      '@type': 'Thing',
      name: 'Ständiger Wohnsitz',
      sameAs: [
        'https://en.wikipedia.org/wiki/Permanent_residency',
        'https://www.wikidata.org/wiki/Q689095',
      ],
    },
    {
      '@type': 'Thing',
      name: 'Aufenthaltsgenehmigung',
      sameAs: [
        'https://en.wikipedia.org/wiki/Residence_permit',
        'https://www.wikidata.org/wiki/Q3529607',
      ],
    },
    {
      '@type': 'Thing',
      name: 'Staatsbürgerschaft',
      sameAs: [
        'https://en.wikipedia.org/wiki/Citizenship',
        'https://www.wikidata.org/wiki/Q42138',
      ],
    },
    {
      '@type': 'Thing',
      name: 'Wirtschaftsbürgerschaft',
      sameAs: [
        'https://en.wikipedia.org/wiki/Economic_citizenship',
        'https://www.wikidata.org/wiki/Q5333443',
      ],
    },
    {
      '@type': 'Thing',
      name: 'Einbürgerung',
      sameAs: [
        'https://en.wikipedia.org/wiki/Naturalization',
        'https://www.wikidata.org/wiki/Q841440',
      ],
    },
  ],
  ru: [
    {
      '@type': 'Thing',
      name: 'Вид на жительство',
      sameAs: ['https://www.wikidata.org/wiki/Q3529607'],
    },
    {
      '@type': 'Thing',
      name: 'Постоянное место жительства',
      sameAs: [
        'https://ru.wikipedia.org/wiki/Постоянное_место_жительства',
        'https://www.wikidata.org/wiki/Q4341038',
      ],
    },
    {
      '@type': 'Thing',
      name: 'Гражданство',
      sameAs: [
        'https://ru.wikipedia.org/wiki/Гражданство',
        'https://www.wikidata.org/wiki/Q42138',
      ],
    },
    {
      '@type': 'Thing',
      name: 'Множественное гражданство',
      sameAs: [
        'https://ru.wikipedia.org/wiki/Множественное_гражданство',
        'https://www.wikidata.org/wiki/Q756296',
      ],
    },
  ],
  tr: [
    {
      '@type': 'Thing',
      name: 'İkamet İzni',
      sameAs: ['https://tr.wikipedia.org/wiki/İkamet_izni'],
    },
    {
      '@type': 'Thing',
      name: 'Sürekli İkamet',
      sameAs: [
        'https://tr.wikipedia.org/wiki/Sürekli_ikamet',
        'https://www.wikidata.org/wiki/Q689095',
      ],
    },
    {
      '@type': 'Thing',
      name: 'Vatandaşlık',
      sameAs: [
        'https://tr.wikipedia.org/wiki/Vatandaşlık',
        'https://www.wikidata.org/wiki/Q42138',
      ],
    },
    {
      '@type': 'Thing',
      name: 'Ekonomik Vatandaşlık',
      sameAs: [
        'https://tr.wikipedia.org/wiki/Ekonomik_vatandaşlık',
        'https://www.wikidata.org/wiki/Q5333443',
      ],
    },
    {
      '@type': 'Thing',
      name: 'Doğal Yolla Vatandaşlık',
      sameAs: [
        'https://tr.wikipedia.org/wiki/Doğal_yolla_vatandaşlık',
        'https://www.wikidata.org/wiki/Q841440',
      ],
    },
  ],
  es: [
    {
      '@type': 'Thing',
      name: 'Permiso de residencia',
      sameAs: [
        'https://es.wikipedia.org/wiki/Permiso_de_residencia',
        'https://www.wikidata.org/wiki/Q3529607',
      ],
    },
    {
      '@type': 'Thing',
      name: 'Residencia permanente',
      sameAs: [
        'https://es.wikipedia.org/wiki/Residencia_permanente',
        'https://www.wikidata.org/wiki/Q689095',
      ],
    },
    {
      '@type': 'Thing',
      name: 'Ciudadanía',
      sameAs: [
        'https://es.wikipedia.org/wiki/Ciudadanía',
        'https://www.wikidata.org/wiki/Q42138',
      ],
    },
    {
      '@type': 'Thing',
      name: 'Ciudadanía económica',
      sameAs: [
        'https://es.wikipedia.org/wiki/Ciudadanía_económica',
        'https://www.wikidata.org/wiki/Q5333443',
      ],
    },
    {
      '@type': 'Thing',
      name: 'Naturalización',
      sameAs: [
        'https://es.wikipedia.org/wiki/Naturalización_(derecho)',
        'https://www.wikidata.org/wiki/Q841440',
      ],
    },
  ],
};
